import { render, staticRenderFns } from "./ModalComponent.vue?vue&type=template&id=0db6fd6a&scoped=true"
import script from "./ModalComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalComponent.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ModalComponent.vue?vue&type=style&index=0&id=0db6fd6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db6fd6a",
  null
  
)

export default component.exports